const MODULE_NAME = 'fulcrum/container/Admin/Client/ClientDialog'
const RESET_FORM = 'fulcrum/container/Admin/Client/ClientDialog/RESET_FORM'
const UPDATE_USERNAME = 'fulcrum/container/Admin/Client/ClientDialog/UPDATE_USERNAME'
const UPDATE_NAME = 'fulcrum/container/Admin/Client/ClientDialog/UPDATE_NAME'
const UPDATE_EMAIL = 'fulcrum/container/Admin/Client/ClientDialog/UPDATE_EMAIL'
const POST_CLIENT = 'fulcrum/container/Admin/Client/ClientDialog/POST_CLIENT'
const POST_CLIENT_ERROR = 'fulcrum/container/Admin/Client/ClientDialog/POST_CLIENT_ERROR'
const POST_CLIENT_START = 'fulcrum/container/Admin/Client/ClientDialog/POST_CLIENT_START'
const POST_CLIENT_SUCCESS = 'fulcrum/container/Admin/Client/ClientDialog/POST_CLIENT_SUCCESS'

export {
  MODULE_NAME,
  RESET_FORM,
  UPDATE_USERNAME,
  UPDATE_NAME,
  UPDATE_EMAIL,
  POST_CLIENT,
  POST_CLIENT_START,
  POST_CLIENT_SUCCESS,
  POST_CLIENT_ERROR,
}
